export default __webpack_public_path__ + "static/media/presentation.5bea0664.png";